/**
 * One status, one badge, one vocabulary.
 *
 * The page this replaces said "Live"/"Not yet" in one place, ✓/○ in another,
 * "On"/"Off" in a third and raw backend strings in a fourth, so nothing could
 * be compared with anything. Everything that has a status now wears this.
 */
import page from '../../../shared/Page.module.css';
import { STAGE_STATUS_LABEL, STAGE_STATUS_TONE, type StageStatus } from './types';

export function StageStatusBadge({ status }: { status: StageStatus }) {
  return (
    <span className={`${page.tag} ${page[STAGE_STATUS_TONE[status]]}`}>
      {STAGE_STATUS_LABEL[status]}
    </span>
  );
}
